__turbopack_context__.v({
  "alertYellow": "LnO-lq_alertYellow",
  "black": "LnO-lq_black",
  "black90": "LnO-lq_black90",
  "cardCopy": "LnO-lq_cardCopy",
  "cardTakeover": "LnO-lq_cardTakeover",
  "cinnamon100": "LnO-lq_cinnamon100",
  "cinnamon20": "LnO-lq_cinnamon20",
  "clickable": "LnO-lq_clickable",
  "cyan": "LnO-lq_cyan",
  "darkStone": "LnO-lq_darkStone",
  "fuschiaPunch": "LnO-lq_fuschiaPunch",
  "inner": "LnO-lq_inner",
  "limeSorbet": "LnO-lq_limeSorbet",
  "olive100": "LnO-lq_olive100",
  "olive20": "LnO-lq_olive20",
  "overlay": "LnO-lq_overlay",
  "shown": "LnO-lq_shown",
  "singleCardRow": "LnO-lq_singleCardRow",
  "softBlack": "LnO-lq_softBlack",
  "teal100": "LnO-lq_teal100",
  "teal20": "LnO-lq_teal20",
  "warmStone": "LnO-lq_warmStone",
  "white": "LnO-lq_white",
});
